import { ISize } from ".";

export interface ISizeSpecifiable<T = number> {
  size: ISize<T>;
}

export function instanceOfISizeSpecifiable<T = number>(instance: any): instance is ISizeSpecifiable<T> {
  return instance
      && (instance.size !== undefined);
}
